(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('hasFolderWritePermission', hasFolderWritePermission);

    hasFolderWritePermission.$inject = ['Principal'];

    function hasFolderWritePermission(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var folder = attrs.hasFolderWritePermission.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasFolderWritePermission(folder)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (folder.length > 0) {
                folder = JSON.parse(folder);
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
